<template>
  <BoxInput type="checkbox" v-bind="$attrs" :checked="checked" />
</template>

<script>
import BoxInput from '@/lego/components/inputs/box/BoxInput.vue';

export default {
  components: {
    BoxInput,
  },
  props: {
    checked: {
      type: Boolean,
    },
  }
};
</script>

<style lang="postcss" scoped>
.formulate-input::v-deep {
  input {
    @apply w-[1.25rem] h-[1.25rem] border-solid p-0 rounded-[5px] border-hairline border-neutral-semilight appearance-none bg-no-repeat bg-center checked:bg-brand-secondary-medium checked:border-brand-secondary-medium m-0;
    background-image: url(/img/web/checkbox-check.svg);
  }
}
</style>
